<template>
  <div :class="model.background" class="py-4 md:py-8">
    <div class="container mx-auto max-w-screen-xl">
      <VcTypography tag="h2" v-if="model.catTitle" class="mb-12">
        {{ model.catTitle }}
      </VcTypography>

      <div class="grid grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-5">
        <template v-for="(category, index) in sortedCategories" :key="index">
          <router-link
            class="flex items-center rounded-xl bg-white p-2 font-bold md:p-4 md:text-lg"
            :to="category.slug ?? '#'"
          >
            <VcImage alt="" :src="category.imgSrc" class="h-12 w-12 md:h-16 md:w-16" lazy />

            <div class="pl-2 font-amaranth leading-5">{{ category.name }}</div>
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { watchEffect, computed } from "vue";
import { useCategory } from "@/shared/catalog/composables";
import type { Category } from "@/core/api/graphql/types";

defineProps({
  model: {
    type: Object,
    required: true,
  },
});

const { category: currentCategory, fetchCategory } = useCategory();

const sortedCategories = computed(() => {
  if (!currentCategory.value || !currentCategory.value.childCategories) {
    return [];
  }
  return [...currentCategory.value.childCategories].sort((a: Category, b: Category) => {
    if (a.priority === undefined) {
      return 1;
    }
    if (b.priority === undefined) {
      return -1;
    }
    return a.priority - b.priority;
  });
});

watchEffect(() => {
  fetchCategory({
    categoryId: "",
    maxLevel: 1,
    onlyActive: true,
  });
});
</script>
